export const attendanceAchievementNames = [
    "Iniciante Dedicado",       // 5 aulas
    "Praticante Regular",       // 10 aulas
    "Frequência Constante",     // 15 aulas
    "Fôlego Inicial",           // 20 aulas
    "Ritmo Firme",              // 25 aulas
    "Dedicação Comprovada",     // 30 aulas
    "Consistência de Ouro",     // 35 aulas
    "Resistência Comprovada",   // 40 aulas
    "Domínio do Ritmo",         // 45 aulas
    "Atleta Focado",            // 50 aulas
    "Veterano da Academia",     // 55 aulas
    "Persistência Inabalável",  // 60 aulas
    "Técnica em Evolução",      // 65 aulas
    "Especialista em Treino",   // 70 aulas
    "Maratonista de Treinos",   // 75 aulas
    "Excelência no Treino",     // 80 aulas
    "Atleta de Elite",          // 85 aulas
    "Performance Superior",     // 90 aulas
    "Mestre do Treino",         // 95 aulas
    "Lenda da Academia"         // 100 aulas
];

export const mockAttendanceAchievements = attendanceAchievementNames.map((name, i) => ({
    id: `achiv_attendance_${i + 1}`,
    name,
    description: `${(i + 1) * 5} Aulas assistidas`,
    type: 'attendance',
    threshold: (i + 1) * 5,
    icon: 'mdi-trophy',
    rewardXp: (i + 1) * 25,
    imageId: `achiv_attendance_${i + 1}`
}));
